import { render } from "./BlogRightSidebar.vue?vue&type=template&id=2e56c0ee"
import script from "./BlogRightSidebar.vue?vue&type=script&lang=js"
export * from "./BlogRightSidebar.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__